import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const RecalibrateIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M3.75 18.75C3.35218 18.75 2.97064 18.592 2.68934 18.3107C2.40804 18.0294 2.25 17.6478 2.25 17.25C2.25 16.8522 2.40804 16.4706 2.68934 16.1893C2.97064 15.908 3.35218 15.75 3.75 15.75C4.14782 15.75 4.52936 15.908 4.81066 16.1893C5.09196 16.4706 5.25 16.8522 5.25 17.25C5.25 17.6478 5.09196 18.0294 4.81066 18.3107C4.52936 18.592 4.14782 18.75 3.75 18.75ZM7.32656 16.125C6.84844 14.6016 5.42812 13.5 3.75 13.5C1.67812 13.5 0 15.1781 0 17.25C0 19.3219 1.67812 21 3.75 21C5.42812 21 6.84844 19.8984 7.32656 18.375H22.875C23.4984 18.375 24 17.8734 24 17.25C24 16.6266 23.4984 16.125 22.875 16.125H7.32656ZM21.75 6.75C21.75 7.14782 21.592 7.52936 21.3107 7.81066C21.0294 8.09196 20.6478 8.25 20.25 8.25C19.8522 8.25 19.4706 8.09196 19.1893 7.81066C18.908 7.52936 18.75 7.14782 18.75 6.75C18.75 6.35218 18.908 5.97064 19.1893 5.68934C19.4706 5.40804 19.8522 5.25 20.25 5.25C20.6478 5.25 21.0294 5.40804 21.3107 5.68934C21.592 5.97064 21.75 6.35218 21.75 6.75ZM16.6734 5.625H1.125C0.501562 5.625 0 6.12656 0 6.75C0 7.37344 0.501562 7.875 1.125 7.875H16.6734C17.1516 9.39844 18.5719 10.5 20.25 10.5C22.3219 10.5 24 8.82188 24 6.75C24 4.67812 22.3219 3 20.25 3C18.5719 3 17.1516 4.10156 16.6734 5.625Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default RecalibrateIcon
